<template>
  <div style="padding: 15px">
    <Detail />
    <div class="content">
      <div class="info">
        <div class="gong">
          <div style="font-size: 14px; text-align: left">自动续费：</div>
          <van-radio-group class="radio" v-model="form.type" icon-size="15px">
            <van-radio :name="true">开启自动续费</van-radio>
            <van-radio :name="false" style="margin-left: 10px">
              关闭自动续费
            </van-radio>
          </van-radio-group>
          <div class="text" v-if="form.type == true">选择续费套餐：</div>
          <el-select
            style="width: 100%; margin-top: 10px"
            v-model="form.mealId"
            placeholder="请选择续费套餐"
            v-if="form.type == true"
          >
            <el-option
              v-for="item in mealList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <div class="texts">支付密码：</div>
          <van-field
            v-model="form.passWord"
            type="number"
            class="field"
            placeholder="请输入支付密码"
          />
          <div class="red-text">支付密码为余额支付的密码</div>
          <!-- <div class="button" @click="submit">确认操作</div> -->
          <van-button
            @click="submits"
            size="small"
            type="info"
            class="button-bottom"
            :loading="loading"
          >
            确认操作
          </van-button>
          <van-collapse
            v-model="activeNames"
            style="text-align: left; margin-top: 30px"
          >
            <van-collapse-item title="自动续费套餐功能介绍" name="1">
              <div>
                1：开启自动续费套餐后套餐即将到期时或者流量用完时系统
                会自动续费套餐。
              </div>
              <div>2：自动续费功能可随时自由关闭。</div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
      <!-- <van-dialog
        style="width: 265px; border-radius: 5px"
        v-model="passWordShow"
        :showConfirmButton="false"
        closeOnClickOverlay
      >
        <div style="font-size: 14px; margin-top: 10px">输入支付密码</div>
        <span style="font-size: 10px; color: red">
          <div>支付密码为余额支付的密码</div>
        </span>
        <div style="width: 100%; margin: 20px 0">
          <van-field
            v-model="form.passWord"
            type="number"
            style="
              width: 80%;
              background-color: #f5f5f5;
              margin: 10px 10%;
              padding: 5px 10px;
              border-radius: 5px;
            "
            placeholder="请输入支付密码"
          />
        </div>

        <div style="width: 100%; margin-bottom: 20px">
          <van-button
            @click="submits"
            size="small"
            style="width: 80%; margin: 0 10%"
            type="info"
            :loading="loading"
          >
            确认操作
          </van-button>
        </div>
      </van-dialog> -->
    </div>
  </div>
</template>

<script>
  import {
    phoneSimCard,
    cardMeal,
    setSetMealId,
    delSetMealId,
  } from "../api/cardOperation";
  import { Dialog } from "vant";
  import Detail from "@/components/Detail.vue";
  export default {
    data() {
      return {
        loading: false,
        detail: {},
        activeNames: ["1"],
        form: {
          type: "",
          mealId: "",
          passWord: "",
        },
        mealList: [],
        passWordShow: false,
      };
    },
    created() {},
    mounted() {
      this.phoneSimCard();
    },
    components: {
      Detail,
    },
    methods: {
      phoneSimCard() {
        phoneSimCard().then((res) => {
          if (res.status) {
            if (res.data.automaticOrderingSetMealId) {
              this.form.type = true;
              this.form.mealId = res.data.automaticOrderingSetMealId;
            } else {
              this.form.type = false;
            }
            this.detail = res.data;
            this.cardMeal(res.data.seriesModel.id);
          }
        });
      },
      cardMeal(val) {
        cardMeal(val).then((res) => {
          this.mealList = res.data;
        });
      },
      recharge() {
        this.$router.push(`/recharge`);
      },
      submit() {
        if (this.form.type == true && !this.form.mealId) {
          this.$toast.fail("请选择套餐");
        } else {
          this.passWordShow = true;
        }
      },
      submits() {
        if (this.form.type == true) {
          if (this.form.mealId) {
            if (this.form.passWord) {
              this.loading = true;
              setSetMealId(
                this.form.mealId,
                localStorage.getItem("meCardNum"),
                this.form.passWord
              )
                .then((res) => {
                  this.loading = false;
                  if (res.code == 0) {
                    this.passWordShow = false;
                    this.form.passWord = "";
                    Dialog.alert({
                      type: "success",
                      title: "温馨提示",
                      message:
                        "开启自动续费成功，请保证余额充足，否则将无法自动续费",
                      confirmButtonText: "好的，我知道了",
                      confirmButtonColor: "#3C9CFF",
                    }).then(() => {
                      // on close
                    });
                  }
                })
                .catch(() => {
                  this.loading = false;
                });
            } else {
              this.$toast("请输入密码");
            }
          } else {
            this.$toast("请选择套餐");
          }
        } else {
          if (this.form.passWord) {
            this.loading = true;
            delSetMealId(localStorage.getItem("meCardNum"), this.form.passWord)
              .then((res) => {
                this.loading = false;
                if (res.code == 0) {
                  this.passWordShow = false;
                  this.form.passWord = "";
                  Dialog.alert({
                    type: "success",
                    title: "温馨提示",
                    message: "关闭自动续费成功，套餐到期时请手动续费！",
                    confirmButtonText: "好的，我知道了",
                    confirmButtonColor: "#3C9CFF",
                  }).then(() => {
                    // on close
                  });
                }
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            this.$toast("请输入密码");
          }
        }
      },
    },
  };
</script>
<style scoped></style>

<style lang="scss" scoped>
  .radio {
    display: flex;
    padding: 11px 10px;
    margin-top: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    border: 1px solid #dcdfe6;
  }
  .text {
    font-size: 14px;
    text-align: left;
  }
  .texts {
    font-size: 14px;
    text-align: left;
    margin-top: 20px;
  }
  .field {
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid #dcdfe6;
    margin-top: 10px;
  }
  .red-text {
    font-size: 10px;
    color: red;
    text-align: left;
    margin-top: 5px;
  }
  .button-bottom {
    width: 100%;
    margin-top: 20px;
    background: linear-gradient(to right, #3c9cff, #9acafc);
    border: 0;
    border-radius: 5px;
  }
  .content {
    height: 150px;
    // background: linear-gradient(to bottom, #3c9cff, #9acafc) !important ;

    .top {
      display: flex;
      justify-content: space-between;
      padding: 10px 15px;
    }
    .card {
      padding: 10px 15px;
      color: #ffffff;
      text-align: left;
      font-size: 14px;
    }
    .info {
      margin-top: 15px;
      border-radius: 10px;
      // background-color: #f5f5f5;
      border: 1px solid #f5f5f5;
      padding-bottom: 10px;
      .title {
        padding: 15px;
        color: #3c9cff;
        font-size: 13px;
        padding-bottom: 5px;
      }
    }
    .gong {
      padding: 10px 15px;
      .button {
        height: 39px;
        border-radius: 5px;
        margin-top: 20px;
        font-size: 16px;
        line-height: 39px;
        color: #ffffff;
        background: linear-gradient(to right, #3c9cff, #9acafc) !important ;
      }
    }
  }
</style>
